

<script>
import {QrcodeStream} from "vue-qrcode-reader/src";
import DibbleAPI from "../../api";
import DibbleJS from "../../dibble";
import DibbleApi from "../../api";

export default {
    name: "ScanOrderQR",
    components: { QrcodeStream },

    data () {
        return {
            camera: 'auto',
            result: null,
            showScanConfirmation: false,
            noRearCamera: false,
            noFrontCamera: false,
            cameraError: ''
        }
    },

    methods: {
        async onInit (promise) {
            try {
                await promise
            } catch (e) {
                const triedFrontCamera = this.camera === 'front'
                const triedRearCamera = this.camera === 'rear'

                const cameraMissingError = e.name === 'OverconstrainedError'

                if (triedRearCamera && cameraMissingError) {
                    this.noRearCamera = true
                }

                if (triedFrontCamera && cameraMissingError) {
                    this.noFrontCamera = true
                }

                this.cameraError = e.toString()
            } finally {
                this.showScanConfirmation = this.camera === "off"
            }
        },

        async onDecode (content) {
            this.result = content
            this.pause()

            const params = {
                request: DibbleAPI.api.validateOrderQrCode,
                qr_code_string: this.result
            }
            DibbleJS.showLoader();
            DibbleJS.callApiRequest(params, this._onScanSuccess);
        },

        unpause () {
            this.camera = 'auto'
        },

        pause () {
            this.camera = 'off'
        },

        timeout (ms) {
            return new Promise(resolve => {
                window.setTimeout(resolve, ms)
            })
        },
        _onScanSuccess(response) {
            DibbleJS.hideLoader();
            if (DibbleApi.isResponseSuccess(response)) {
                if (response.is_valid) {
                    switch (response.order_type.toLowerCase()) {
                        case 'rental': {
                            this.$router.push(`/rental-order/${response.order_id}`);
                            break
                        }

                        case 'moorage': {

                            //TODO Tran
                            DibbleJS.toastErrorMessage("Not support Moorage order at this time.")
                            this.unpause()
                            break
                        }

                        default: {
                            DibbleJS.toastErrorMessage("Invalid Order type for this code.")
                            this.unpause()
                        }
                    }
                } else {
                    DibbleJS.toastErrorMessage("QR code is invalid. Please try again!")
                    this.unpause()
                }
            } else {
                DibbleJS.toastErrorMessage(response.message)
                this.unpause()
            }
        }
    }
}
</script>
<template src="./template/index.html"></template>
<style>
    .scanner-box { position: relative }
    #qr-code-camera {
        position: absolute;
        top: 195px;
    }
    .user-did-not-watch-video span {
        background-color: red;
        color: white;
        font-weight: bold;
        padding: 5px;
        font-size: 20px;
    }
</style>
